import React, { useState, useMemo, useEffect } from "react";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import Navbar from "../../Navbar";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import EditNoteIcon from "@mui/icons-material/EditNote";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  Button,
  Container,
  Alert,
  Box,
  Typography,
  ListItemIcon,
  MenuItem,
} from "@mui/material";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import { getData } from "../../../services/library";
import MotivosDesplegablesDelete from "./MotivosDesplegablesDelete";
import MotivosDesplegablesForm from "./MotivosDesplegablesForm";
import { logEventos } from "../../../services/services";
const MotivosDesplegables = () => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [rowInfo, setRowInfo] = useState({});
  const [motivosDesplegables, setMotivosDesplegables] = useState([]);
  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [openFormModal, setOpenFormModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [idToDelete, setIdToDelete] = useState(-1);
  const [estadoMotivo, setEstadoMotivo] = useState("");

  const traerMotivos = () => {
    getData("/SP_motivos_desplegables/all", (data) => {
      setMotivosDesplegables(Array.isArray(data) ? data : []);
    });
  };

  useEffect(() => {
    traerMotivos();
  }, []);

  const handleOpenCloseFormModal = () => {
    setOpenFormModal(!openFormModal);
  };

  const handleOpenCloseDeleteModal = () => {
    setOpenDeleteModal(!openDeleteModal);
  };

  const mostrarAlertaTemporal = (mensaje, severidad) => {
    setMostrarAlerta(true);
    setMessage(mensaje);
    setSeverity(severidad);

    setTimeout(() => {
      setMostrarAlerta(false);
    }, 5000);
  };

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "primary",
    size: "small",
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const columns = useMemo(
    () => [
      { header: "ID", accessorKey: "id", size: 60 },
      { header: "Valor", accessorKey: "valor", size: 300 },
      { header: "User", accessorKey: "user", size: 60 },
    ],
    []
  );

  const globalTheme = useTheme();
  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary,
          info: {
            main: "rgb(255,122,0)",
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)"
                : "#000",
          },
        },
        typography: {
          button: {
            textTransform: "none",
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem",
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  useEffect(() => {
  logEventos(
    "acceso al menú xTablas Ref RRHH",
   "RRHH", 
   "Desplegable de motivos",
    localStorage.getItem("user"));
}, []);
  return (
    <>
      {openFormModal && (
        <MotivosDesplegablesForm
          isEditMode={isEditMode}
          rowInfo={isEditMode ? rowInfo : {}}
          handleOpenCloseModalForm={handleOpenCloseFormModal}
          getMotivos={traerMotivos}
          mostrarAlertaTemporal={mostrarAlertaTemporal}
        />
      )}
      {openDeleteModal && (
        <MotivosDesplegablesDelete
          open={openDeleteModal}
          id={idToDelete}
          getMotivos={traerMotivos}
          estado={estadoMotivo}
          mostrarAlerta={mostrarAlertaTemporal}
          onClose={() => setOpenDeleteModal(false)}
        />
      )}
      {mostrarAlerta && (
        <Alert
          severity={severity}
          sx={{
            zIndex: 1600,
            position: "fixed",
            top: "20px",
            right: "20px",
            width: "auto",
            borderRadius: "8px",
            backgroundColor:
              severity === "success"
                ? "#d8e6d3"
                : severity === "error"
                ? "#efc3c3"
                : severity === "warning"
                ? "#f0efb6"
                : "#e6e6e6",
          }}
        >
          {message}
        </Alert>
      )}
      <Navbar />
      <Container maxWidth="xl" mt={1}>
        {motivosDesplegables ? (
          <Box mt={2} mb={4}>
            <ThemeProvider theme={tableTheme}>
              <MaterialReactTable
                autoResetPageIndex={false} //Para que no se resete la paginacion al actualizar o eliminar una fila
                enableToolbarInternalActions={true}
                enableGrouping
                layoutMode="grid"
                muiTableHeadCellProps={tableHeadCellProps}
                muiTableBodyCellProps={({ row }) => ({
                  align: "left",
                  sx: {
                    color: "black",
                    borderColor: "black",
                    backgroundColor:
                      row.original.activa === 1 ? "#fff" : "#efc3c3",
                    wordWrap: "break-word", // Permite que el texto se divida cuando sea necesario
                    whiteSpace: "normal", // Permite que el texto ocupe varias líneas
                  },
                })}
                enableColumnActions={true}
                enableColumnFilters={false}
                enableHiding={false}
                enableDensityToggle={false}
                localization={MRT_Localization_ES}
                enableColumnDragging={false}
                initialState={initialState}
                // renderDetailPanel={renderDetailPanel}
                muiSearchTextFieldProps={muiSearchTextFieldProps}
                columns={columns}
                data={motivosDesplegables}
                enableStickyFooter
                enableRowActions
                positionActionsColumn="last"
                renderToolbarInternalActions={({ table }) => <></>}
                renderTopToolbarCustomActions={() => (
                  <Box sx={{ display: "flex" }}>
                    <Box
                      sx={{
                        marginRight: 2,
                      }}
                    >
                      <Button
                        variant="contained"
                        color="success"
                        startIcon={<AddBoxTwoToneIcon color="asd" />}
                        aria-haspopup="true"
                        onClick={() => {
                          setIsEditMode(false);
                          handleOpenCloseFormModal();
                        }}
                      >
                        Añadir motivo
                      </Button>
                    </Box>
                    <Typography
                      variant="poster"
                      style={{ fontSize: 26, textAlign: "center" }}
                    >
                      Desplegable de motivos
                    </Typography>
                  </Box>
                )}
                renderRowActionMenuItems={({ closeMenu, row }) => (
                  <Box>
                    <MenuItem
                      onClick={() => {
                        setIsEditMode(true);
                        setRowInfo(row.original);
                        closeMenu();
                        handleOpenCloseFormModal();
                      }}
                    >
                      <ListItemIcon>
                        <EditNoteIcon sx={{ color: "skyblue" }} />
                      </ListItemIcon>
                      Editar
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        handleOpenCloseDeleteModal();
                        setIdToDelete(row.original.id);
                        setEstadoMotivo(row.original.activa === 1 ? 0 : 1);
                        closeMenu();
                      }}
                    >
                      {row.original.activa === 1 ? (
                        <ListItemIcon>
                          <HighlightOffIcon color="error" />
                        </ListItemIcon>
                      ) : (
                        <ListItemIcon>
                          <CheckCircleIcon color="success" />
                        </ListItemIcon>
                      )}
                      {row.original.activa === 1
                        ? "Desactivar motivo"
                        : "Activar motivo"}
                    </MenuItem>
                  </Box>
                )}
              />
            </ThemeProvider>
          </Box>
        ) : null}
      </Container>
    </>
  );
};

export default MotivosDesplegables;
